import React ,{ useState , useEffect } from 'react';
import webapi from '../../../api/webapi';
import Header from '../Header/Header';
import Loading from '../modal/Loading';
import Footer from '../Footer/Footer';
import RelativeSearchBox from './RelativeSearchBox';

const Relative = (props) => {
    
    const [loadingShow,setLoadingShow] = useState(false)
    const [languageInfo,setLanguageInfo] = useState(undefined)
    const [pageData,setPageData] = useState(undefined)

    useEffect(()=>{
        async function getLanguageInfo(languageCode){
            const responseResultlanguageinfo = await webapi.get('pages/languageInfo/'+languageCode);
            //console.log(responseResultlanguageinfo.data.length);
            //console.log(responseResultlanguageinfo.data);
            
            if (responseResultlanguageinfo && responseResultlanguageinfo.data.length>0)
            {
                setLanguageInfo(responseResultlanguageinfo.data);
                //setLang(responseResultlanguageinfo.data[0].Code);
                document.getElementsByTagName('html')[0].setAttribute("lang", responseResultlanguageinfo.data[0].Code);
                document.getElementsByTagName('html')[0].setAttribute("dir", responseResultlanguageinfo.data[0].Direction);
            }
            else
            {
                setLanguageInfo([{Code:"fa",Title:"فارسی",Direction:"rtl"}]);
                //setLang(responseResultlanguageinfo.data[0].Code);
                document.getElementsByTagName('html')[0].setAttribute("lang","fa");
                document.getElementsByTagName('html')[0].setAttribute("dir", "rtl");
            }
        }



        if (new URLSearchParams(props.location.search).get("lang")!=null)
        {
            //console.log('LangFromURL: ',new URLSearchParams(props.location.search).get("lang"));
            //console.log('LangFromSubDomain: ',window.location.host.split(".")[0]);
            getLanguageInfo(new URLSearchParams(props.location.search).get("lang"));
            //console.log(languageInfo);
        }else{
            setLanguageInfo([{Code:"fa",Title:"فارسی",Direction:"rtl"}]);
            document.getElementsByTagName('html')[0].setAttribute("lang","Fa");
            document.getElementsByTagName('html')[0].setAttribute("dir", "rtl");
        }

        //fetch('https://api.ipify.org/?format=json')
        // fetch('https://geolocation-db.com/json/')
        // .then(response => {
        //     return response.json();
        // }, "jsonp")
        // .then(res => {
        //     setLog('pages/log/Relative/visit/'+res.IPv4.replaceAll('.',','))
        // })
        // .catch(err => setLog('pages/log/Relative/visit/'+err));
        
    },[])

    // async setLog(Data) {
    //     await webapi.post(Data);
    // }

    

    useEffect (()=>{
        async function getPage() {
            if (languageInfo)
            {
                const pageList = await webapi.get('pages/datapages/204/'+languageInfo[0].Code);
                //console.log(pageList);
                setPageData(pageList.data);
            }else{
                const pageList = await webapi.get('pages/datapages/204/fa');
                //console.log(pageList);
                setPageData(pageList.data);
            }
        }

        getPage();
    },[languageInfo])

    
    if (pageData && languageInfo) {
        return (
                <div>
                    <Header languageInfo = {languageInfo}/>
                        <div className="container-fluid" id="innerpage_row_1">
                            <div className="container">
                            <h1 id="page_title">{pageData.length!==0 && pageData[0].F204!== undefined?pageData[0].F204:204/*با هم آیی*/}</h1>
                            <h2 id="page_title_dek">{pageData.length!==0 && pageData[0].F20400!== undefined?pageData[0].F20400:20400/*بررسی با هم آیی کلمات در متون*/}</h2>
                            <hr className="halfwidth" />
                            </div>
                        </div>
                    <Loading loadingShow={loadingShow} />
                    <RelativeSearchBox  pageData={pageData}
                                        lang = {languageInfo[0].Code}
                    />                
                    <Footer lang = {languageInfo[0].Code}/>
                </div>   
        )
    }
    else
    {
        return null
    }
 }

 export default Relative;